import { render, staticRenderFns } from "./TotalTemplate.vue?vue&type=template&id=c14f11ca&scoped=true&"
import script from "./TotalTemplate.vue?vue&type=script&lang=js&"
export * from "./TotalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14f11ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c14f11ca')) {
      api.createRecord('c14f11ca', component.options)
    } else {
      api.reload('c14f11ca', component.options)
    }
    module.hot.accept("./TotalTemplate.vue?vue&type=template&id=c14f11ca&scoped=true&", function () {
      api.rerender('c14f11ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TotalTemplate.vue"
export default component.exports